/* eslint-disable */
import { Box, Typography, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import colors from '../../../constants/colors'
import { AppDispatch } from '../../../store'
import { openCase } from '../../../store/reports/reportsSlice'
import { IValues, triageLevelStates } from '../../../store/reports/types'
import usersSelectors from '../../../store/users/usersSelectors'
import timeUtils from '../../timeUtils'
import CardTAG from '../../../components/CardTAG'

import { IReportsBoxItem } from './types'
import { FC } from 'react'
import authSelectors from '../../../store/auth/authSelectors'
import { APP_MODE } from '../../../sharedTypes'

const ReportsBoxItem: FC<IReportsBoxItem> = ({ report, error = false }) => {
  const dispatch = useDispatch<AppDispatch>()
  const appMode = useSelector(authSelectors.userOrganizationType)
  const teamMembers = useSelector(usersSelectors.teamMembers)
  const navigate = useNavigate()

  const routeChange = () => {
    dispatch(openCase({ caseId: report?.id, caseStatus: report.report_status.status }))
    localStorage.setItem("currentReportId", String(report?.id));

    if (
      report?.triage_level &&
      report.triage_level !== triageLevelStates.TRANSFERED_FOR_ASSIGNMENT
    ) {
      if (
        report.triage_level === triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED &&
        teamMembers?.length === 0
      ) {
        navigate('/cases/initialReport')
        return
      }

      if (appMode !== APP_MODE.full) {
        navigate('/cases/initialReport')
        return
      }

      navigate('/cases/overview')
      return
    }

    navigate('/cases/initialReport')
  }

  const helpFunction = (reports: IValues[]) => {
    return reports.map((report, index) => {
      const valueRender = report.value ? report.value : '-'
      return (
        <Box className='t-vbox t-gap-4' key={`${report?.label}${index}`}>
          <span className='t-font-size-small t-font-bold t-label'>{report?.label}</span>
          <span className='t-font-size-body'>{valueRender}</span>
        </Box>
      )
    })
  }

  const getString = (array: any[]) => {
    if (!array || array?.length === 0) {
      return '-'
    }
    let newString = ''

    array.forEach((item, index) => {
      newString += `${index !== 0 ? ',' : ''}${item?.full_name}`
    })

    return newString ?? '-'
  }

  const getWhatIsTheGeneralNatureQuestion = () => {
    if (!report || !report.answers?.length) {
      return '-'
    }

    const questionItem = report.answers.find(
      (item: { question: { text: string } }) =>
        item.question?.text === 'What is the general nature of the problem',
    )
    if (!questionItem) {
      return '-'
    }

    const answers = questionItem.answers.map(
      (answer: { question_option: { text: any } }) => answer.question_option?.text,
    )
    return answers.join(', ')
  }

  const resolveTitle = () => {
    return report?.triage_level ? (
      <span className={'t-report-uuid t-overflow-ellipsis t-font-bold t-font-size-header'}>
        #{report.unique_code}
      </span>
    ) : (
      <>
        <Box className={'t-report-new-chip t-color-white t-d-iflex t-font-size-small t-font-bold'}>
          New
        </Box>{' '}
        <span
          className={'t-report-uuid t-overflow-ellipsis t-font-bold t-font-size-header'}
        >{`#${report.unique_code}`}</span>
      </>
    )
  }

  return (
    <CardTAG
      title={<Box className={'t-report-title t-d-flex t-align-items-center'}>{resolveTitle()}</Box>}
      boxError={error}
    >
      <Box className='t-vbox t-justify-content-between t-flex-1'>
        <Box className='t-vbox t-gap-18 t-pb-36'>
          {report?.name !== 'TEMPORARY_CASE_NAME' && (
            <span className='t-report-name t-font-size-header t-font-bold'>{report?.name}</span>
          )}
          {helpFunction([
            { label: 'Date', value: timeUtils.getFormatedDate(report?.created_at) },
            { label: 'Subjects', value: getString(report?.subjects) },
            { label: 'Victims', value: getString(report?.victims) },
            { label: 'Reporting Party', value: getString(report?.reporters) },
            { label: 'Tier Level', value: `${report?.tier_level}` },
            {
              label: 'What is the general nature of the problem?',
              value: getWhatIsTheGeneralNatureQuestion(),
            },
          ])}
        </Box>
        <Button
          variant='outlined'
          sx={{ borderRadius: '1rem', border: '1px solid black !important' }}
          onClick={routeChange}
        >
          <Typography variant='bodyRegular' sx={{ color: colors.BLACK }}>
            Open Report
          </Typography>
        </Button>
      </Box>
    </CardTAG>
  )
}

export default ReportsBoxItem
